import type { PulseReport } from '../../types/pulseReport'

const markdownLines = (markdown: string) =>
  markdown.split(/\n+/).map((line) => line.trim()).filter(Boolean)

export const PulseBody = ({ report }: { report: PulseReport }) => (
  <>
    {markdownLines(report.content.narrativeMarkdown).map((line, index) => {
      if (line.startsWith('# ')) return <h2 key={`${line}-${index}`}>{line.slice(2)}</h2>
      if (line.startsWith('## ')) return <h3 key={`${line}-${index}`}>{line.slice(3)}</h3>
      if (line.startsWith('- ')) return <p key={`${line}-${index}`} className="pulseReportReader__bullet">{line.slice(2)}</p>
      return <p key={`${line}-${index}`}>{line}</p>
    })}
    {report.content.sections.length ? (
      <div className="pulseReportReader__sections">
        {report.content.sections.map((section) => (
          <section key={section.id}>
            <strong>{section.title}</strong>
            <p>{section.body}</p>
          </section>
        ))}
      </div>
    ) : null}
  </>
)
